module.exports = __webpack_public_path__ + "static/media/icon-flag.40b4b9e7.svg";